import React from "react";
import ApprovePageSection from "../../Sections/ApproveSection/Content";
const ApprovePage = () => {
  return <ApprovePageSection />;
};

export default ApprovePage;
